module.exports = __webpack_public_path__ + "static/media/FolloGuide_30-05-19.5242d61c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/advertisers/modules/tutorials/assets/pdfs/en/FolloGuide_30-05-19.pdf
// module id = ./src/advertisers/modules/tutorials/assets/pdfs/en/FolloGuide_30-05-19.pdf
// module chunks = 8